module.exports = __webpack_public_path__ + "static/img/qbz.c1640eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qbz.jpg
// module id = tDQw
// module chunks = 1